import { useRef, useState } from "react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const useVideoControls = () => {
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(true);
    const [muted, setMuted] = useState(true);

    const togglePlay = () => {
        const v = videoRef.current;
        if (!v) return;
        const shouldPlay = v.paused;
        setPlaying(shouldPlay);
        if (shouldPlay) v.play().catch(() => setPlaying(false));
        else v.pause();
    };

    const toggleSound = () => {
        const v = videoRef.current;
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) v.volume = 1;
        setMuted(v.muted);
    };

    return { videoRef, playing, muted, togglePlay, toggleSound };
};

const ControlButton = ({ onClick, testId, children }) => (
    <button
        onClick={onClick}
        data-testid={testId}
        className="font-mono2 text-[10px] tracking-[0.25em] uppercase px-3 py-2 bg-[rgba(10,10,10,0.65)] backdrop-blur-sm border border-[var(--line)] hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors duration-300"
    >
        {children}
    </button>
);

const Caption = () => (
    <div className="md:mx-auto md:max-w-[86%] mt-4 flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2 font-mono2 text-[9px] md:text-[10px] tracking-[0.2em] text-[var(--mute)] uppercase">
        <span data-testid="aracne-caption">Fashion film — direction / shooting / editing, 2025</span>
        <span>With T. Antonelli, A. Costantini, A. Pintauro</span>
    </div>
);

export const Aracne = () => {
    const { videoRef, playing, muted, togglePlay, toggleSound } = useVideoControls();

    return (
        <section className="pt-28 md:pt-44" data-testid="aracne-section">
            <SectionHeading index="03" title="Aracne" id="aracne" />
            <Reveal className="px-6 md:px-12">
                <div className="relative md:mx-auto md:max-w-[86%] group" data-testid="aracne-video-frame">
                    <video
                        ref={videoRef}
                        src="/assets/video/aracne.mp4"
                        poster="/assets/video/aracne-poster.jpg"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        className="w-full h-auto bg-[#101010]"
                        data-testid="aracne-video-player"
                    />
                    <div className="absolute bottom-4 right-4 flex gap-2">
                        <ControlButton onClick={toggleSound} testId="aracne-sound-toggle">
                            {muted ? "Sound off" : "Sound on"}
                        </ControlButton>
                        <ControlButton onClick={togglePlay} testId="aracne-play-toggle">
                            {playing ? "Pause" : "Play"}
                        </ControlButton>
                    </div>
                </div>
                <Caption />
            </Reveal>
        </section>
    );
};
